// Mesma forma/valores por omissão usados em PrepareMeetingProvider.js ao semear
// timers.points de todos os pontos no arranque da reunião — necessário replicar aqui
// porque um ponto associado já com a reunião em curso nunca passa por aquele fluxo.
const defaultPeriods = {
  presentation: { title: '', enabled: true, time_enabled: true, time: 3 * 60 },
  protests: { title: '', enabled: true, time_enabled: true, time: 3 * 60 },
};

export const getDiscussionPointTimerId = point =>
  point.proposal_id !== null ? `proposal-${point.id}` : `point-${point.id}`;

const buildDiscussionPointTimer = (typologyPeriods = {}, point) => {
  const presentationPeriod = typologyPeriods.presentation || defaultPeriods.presentation;
  const protestsPeriod = typologyPeriods.protests || defaultPeriods.protests;

  const pointTimers = {};

  if (presentationPeriod.enabled && presentationPeriod.time_enabled) {
    pointTimers.presentation = {
      initialValue: presentationPeriod.time,
      value: presentationPeriod.time,
      state: 'stop',
      countdown: true,
      title: presentationPeriod.title || '',
    };
  }

  if (protestsPeriod.enabled && protestsPeriod.time_enabled) {
    pointTimers.protests = {
      initialValue: protestsPeriod.time,
      value: protestsPeriod.time,
      state: 'stop',
      countdown: true,
      title: protestsPeriod.title || '',
    };
  }

  return { timerId: getDiscussionPointTimerId(point), pointTimers };
};

export default buildDiscussionPointTimer;
